module.controller('professionalSamplingTaskCtrl', [ '$timeout','$window','$http', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'dateUtilService',
                                                    'securityService', professionalSamplingTaskCtrlFn ]);

function professionalSamplingTaskCtrlFn($timeout,$window,$http, $scope, $rootScope, $state, planSamplingService, alertService, dateUtil, securityService) {

	var vm = $scope;

	vm.SAMPLE_ELEMENT_CHECKED = SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED;
	//var idUser = null;

	vm.idUser = null;

	var today = new Date();
	vm.reportDate = today;

	vm.samples = [];
	vm.tip = {};
	vm.isCollapsed = true;
	vm.isCollapsedR = true;


	vm.sampleStates = SAMPLE_STATE.valuesTask();

	vm.filters = {
			client : {},
			idSample : {},
			states : []
	}
	vm.stateIni = null;
	vm.clientCustomFilter = {
			active : true
	}
	vm.pagination = {
			current : 1,
			total : 0
	};




	/*
	 * opciones para el qTip de fecha de programación
	 */
	vm.qtipScheduleDateOption = {
			style : 'qtip-dark  qtip-shadow'
	};

	vm.qtipClientOption = {
			style : 'qtip-dark  qtip-shadow'
	}

	vm.onClientChange = function(client) {
		vm.pagination.current = 1;
		realoadFilters();
		// loadSamples();
	}

	vm.onIdSampleChange = function(idSample) {
		vm.pagination.current = 1;
		realoadFilters()
		// loadSamples();
	}

	vm.onStateChange = function(state) {
		vm.pagination.current = 1;
		realoadFilters();
		// loadSamples();
	}

	vm.onPageChange = function(page) {
		vm.pagination.current = page;
		realoadFilters();
	}

	/*
	 * refresca los query parameters de la url
	 */
	function realoadFilters() {
		var obj = {
				idClient : '',
				states : [],
				sampleId : ''
		};
		// cliente
		if (vm.filters.client.selected && vm.filters.client.selected.length > 0) {
			obj.idClient = vm.filters.client.selected[0].id;
		}
		// estados
		if (vm.filters.states.selected && vm.filters.states.selected.length > 0) {
			obj.states = [];
			for ( var i in vm.filters.states.selected) {
				obj.states.push(vm.filters.states.selected[i].enumName);
			}
		}
		// muestra
		if (vm.filters.idSample.selected && vm.filters.idSample.selected.length > 0) {
			obj.sampleId = vm.filters.idSample.selected[0];
		}
		// paginacion
		if (vm.pagination.current) {
			obj.page = vm.pagination.current;
		}

		$state.go('home.professionalSamplingTask.sample', obj, {
			reload : 'home.professionalSamplingTask.sample',
			notify : false,
		});
	}

	$scope.$on('$locationChangeSuccess', function(ev, newUrl, oldUrl, newState, oldState) {
		//se cargan de nuevo los filtros, por si fue un evento externo
		loadFilters();
		loadSamples();
	});

	vm.refreshSample = function(idPlan, idSampling, idSample) {
		planSamplingService.getSampleBasicInfo(idPlan, idSampling, idSample).then(function(response) {

			var sample = response.getData();
			sample.scheduleDate = dateUtil.formatMomentDateTime(sample.scheduleDate);
			sample.className = getConstantById(SAMPLE_STATE, sample.state).className;

			var idx = vm.samples.findIndex(function(s) {
				return s.id === idSample;
			});

			vm.samples[idx] = sample;

		}, function(response) {
		});
	}

	vm.activaTab = function(tab) {
		$('.nav-pills a[href="#tab1"]').tab('show');
	};

	function init() {

		loadFilters();
		loadSamples();

		
		/* Load user data session */
		securityService.loadUserLoggedInfo().then(function(response) {
			var userSession = response;
			vm.idUser = userSession.id;
			
		}, function(response) {
			alertService.showWarning('Error cargando información de sesión del usuario');
		});

		$("#iconHelpState").qtip({
			content : {
				text : $("#helpState"),
				title : {
					text : "Código de colores de estados",
					button : true
				}
			},
			position : {
				my : 'left center',
				at : 'right center',
				adjust : {
					scroll : false,
					mouse : false
				}
			},
			show : {
				event : 'click',
				solo : true
			},
			hide : {
				event : 'unfocus'
			},
			style : {
				classes : 'qtip-bootstrap qtip-shadow qtip-rounded',
				width : "500px"
			}
		});
	}

	function loadFilters(){
		if ($state.params.sampleId)
			vm.filters.idSample.selected = [$state.params.sampleId];
		if ($state.params.idClient)
			vm.filters.client.id = $state.params.idClient;
		if ($state.params.states) {
			if (angular.isArray($state.params.states)) {
				vm.stateIni = $state.params.states.map(function(s) {
					return getConstantById(SAMPLE_STATE, s);
				});
			} else {
				vm.stateIni = [];
				vm.stateIni.push(getConstantById(SAMPLE_STATE, $state.params.states));
			}
			vm.filters.states.selected = vm.stateIni;
		}
		if ($state.params.page) {
			vm.pagination.current = $state.params.page;
		}
	}

	function loadSamples() {

		var filter = {};
		var page = vm.pagination.current;
		// page = page == undefined ? 1 : page;
		// vm.pagination.current = page;

		var ps = $rootScope.pageSize;
		filter.offset = (page - 1) * ps;
		filter.limit = ps;

		filter.state = [ SAMPLE_STATE.ASIGNED.enumName, SAMPLE_STATE.SAMPLE_ELEMENT_CHECKED.enumName, 
			SAMPLE_STATE.TAKEN_NOT_SIGNED.enumName, SAMPLE_STATE.TAKEN.enumName ];

		if (vm.filters.client.selected && vm.filters.client.selected.length > 0) {
			filter.client = vm.filters.client.selected[0].id;
		} else if (vm.filters.client.id) {
			filter.client = vm.filters.client.id;
		}

		if (vm.filters.states.selected && vm.filters.states.selected.length > 0) {
			filter.state = [];
			for ( var i in vm.filters.states.selected) {
				filter.state.push(vm.filters.states.selected[i].enumName);
			}
		}

		if (vm.filters.idSample.selected && vm.filters.idSample.selected.length > 0) {
			filter.idSample = vm.filters.idSample.selected[0];
		}

		// solo los planes de mmuestreo que no esten anulados
		filter['planSampling.state.notin'] = PLAN_SAMPLING_STATE.ANNUL.enumName;

		filter.orderby = [ "scheduleDate asc" ];

		planSamplingService.searchByProfessionalSamplingBasicInfo(filter).then(function(response) {
			var result = response.getData();
			vm.samples = result.results;

			vm.pagination.total = result.totalRegisters;

			vm.samples.forEach(function(s) {
				s.scheduleDate = dateUtil.formatMomentDateTime(s.scheduleDate);
				s.className = getConstantById(SAMPLE_STATE, s.state).className;
				s.tipClient = {};
			});

			// $state.go('home.professionalSamplingTask', {
			// reload : 'home.professionalSamplingTask.sample'
			// });
		}, function(response) {
		});
	}

	vm.toStringParameter = function(param){

		return dateUtil.toBirtDate(param)
		
	};

	init();
}